<template>
  <div>
    <Navbar/>
    <h4>Elemento</h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idElemento" class="form-label">IdElemento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idElemento" name="idElemento" v-model="datoElemento.idElemento" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idClasElem" class="form-label"> Clas Elem</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idClasElem" name="idClasElem" v-model="datoElemento.idClasElem">
                      <option v-for="clasElem in clasElems" :value="clasElem.idClasElem" :key="clasElem.idClasElem">
                        {{ clasElem.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombre" name="nombre" v-model="datoElemento.nombre" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="codigo" class="form-label">Codigo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="codigo" name="codigo" v-model="datoElemento.codigo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarElemento" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditElemento" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdPlantillaDet</th>
          <th scope="col">IdPlantilla</th>
          <th scope="col">IdElemento</th>
          <th scope="col">Estado</th>
          <th scope="col">PlantillaNombre</th>
          <th scope="col">ElementoNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="plantilladet in datosPaginados" :key="plantilladet.idPlantillaDet">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(plantilladet.idPlantillaDet)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(plantilladet.idPlantillaDet)" title="Editar">edit_square</i></td>
          <td>{{plantilladet.idPlantillaDet}}</td>
          <td>{{plantilladet.idPlantilla}}</td>
          <td>{{plantilladet.idElemento}}</td>
          <td>{{plantilladet.estado}}</td>
          <td>{{plantilladet.plantillaNombre}}</td>
          <td>{{plantilladet.elementoNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteElemento(plantilladet.idPlantillaDet)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idPlantillaDet" class="form-label">IdPlantillaDet</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPlantillaDet" name="idPlantillaDet" v-model="datoPlantillaDet.idPlantillaDet" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idPlantilla" class="form-label"> Plantilla</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPlantilla" name="idPlantilla" v-model="datoPlantillaDet.idPlantilla">
                      <option v-for="plantilla in plantillas" :value="plantilla.idPlantilla" :key="plantilla.idPlantilla">
                        {{ plantilla.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idElemento" class="form-label">IdElemento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idElemento" name="idElemento" v-model="datoPlantillaDet.idElemento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarPlantillaDet" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPlantillaDet" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      elementos : [],
      datoElemento : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idElemento: '',
      clasElems : [],
// Variables master
// Variables details
      plantilladets : [],
      datoPlantillaDet : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      plantillas : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idElemento = this.$route.params.p_idelemento
    this.abrirEditar(this.p_idElemento)
    this.getDataPagina(this.paginaActual)
    this.fetchClasElems()
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'idClasElem'
        ,'nombre'
        ,'codigo'
      ];
      const requiredFieldsText = [
        'idClasElem'
        ,'nombre'
        ,'codigo'
      ];
      return validarForm(this.datoElemento, requiredFields, requiredFieldsText);
    },
    async guardarElemento(){
      if(this.validarForm() === 1){
        try {
          await api.post('/elementos', this.datoElemento)
          swal("Correcto!", "Elemento creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditElemento(){
      if(this.validarForm() === 1){
        try {
          await api.post('/elementos', this.datoElemento)
          swal("Correcto!", "Elemento creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoElemento={}
      this.titulo   = 'Crear Elemento'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idElemento){
      this.modalWindow = true
      if(idElemento != null){    
           api.get('/vwelementos/'+idElemento).then(resp=>{
          this.datoElemento = resp.data;
           });
      }
      this.titulo   = 'Editar Elemento'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarElemento(){
      this.$router.push('/Elemento')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.plantilladets.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwplantilladets/nombre/'+this.nombreBusqueda).then(response=>{
          this.plantilladets=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.plantilladets.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwplantilladets').then(response=>{
      this.plantilladets=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.plantilladets.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'idClasElem'
        ,'nombre'
        ,'codigo'
      ];
      const requiredFieldsText = [
        'idClasElem'
        ,'nombre'
        ,'codigo'
      ];
      return validarForm(this.datoElemento, requiredFields, requiredFieldsText);
    },
    async guardarPlantillaDet(){
      if(this.validarForm() === 1){
        try {
          this.datoPlantillaDet.idElemento = this.datoElemento.idElemento;
          await api.post('/plantilladets', this.datoPlantillaDet)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "PlantillaDet creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPlantillaDet(){
      if(this.validarForm() === 1){
        try {
          await api.post('/plantilladets', this.datoPlantillaDet)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "PlantillaDet creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoPlantillaDet={}
      this.titulo   = 'Crear Elemento'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idPlantillaDet){
      this.modalWindow = true
      if(idPlantillaDet != null){    
           api.get('/vwplantilladets/'+idPlantillaDet).then(resp=>{
          this.datoPlantillaDet = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Elemento'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idPlantillaDet){
      this.modalWindow = true
      if(idPlantillaDet != null){
        this.$router.push('/plantilladetmd/'+idPlantillaDet)
      }
    },
    async deletePlantillaDet (idPlantillaDet) {
      try{
        await api.delete('/plantilladets/'+idPlantillaDet)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchClasElems() {
      fetch('http://localhost:8080/api/v1/claselems')
        .then(response => response.json())
        .then(data => {
          this.clasElems = data;
        })
        .catch(error => {
          console.error('Error fetching clasElems:', error);
        });
    },
    fetchPlantillas() {
      fetch('http://localhost:8080/api/v1/plantillas')
        .then(response => response.json())
        .then(data => {
          this.plantillas = data;
        })
        .catch(error => {
          console.error('Error fetching plantillas:', error);
        });
    },
    fetchElementos() {
      fetch('http://localhost:8080/api/v1/elementos')
        .then(response => response.json())
        .then(data => {
          this.elementos = data;
        })
        .catch(error => {
          console.error('Error fetching elementos:', error);
        });
    },
  },
}
</script>
